export default {
  searchTerm: (state) => {
    // Return a number directly, not a Promise or reactive object
    return String(state.searchTerm) || '';
  },
  pageSize: (state) => {
    return Number(state.pageSize) || 10;
  },
  filterOptions: (state) => state.filterOptions,
  filterBy: (state) => state.filterBy,
  sortDir: (state) => {
    return String(state.sortDir) || 'desc';
  },
  orderBy: (state) => {
    return String(state.orderBy) || 'id';
  },
  totalCount: (state) => {
    return Number(state.totalCount) || 0;
  },
  unreadForRequest: (state) => (id) => {
    if (id == null) return 0
    return Number(state.requestUnreadById?.[String(id)] || 0)
  },
  unreadTotalAllRequests: (state) => {
    const map = state.requestUnreadById || {}
    return Object.values(map).reduce((sum, n) => sum + Number(n || 0), 0)
  },
  cleanRequest: (state) => state.cleanRequest,
  cleanVehicle: (state) => state.cleanVehicle,
  requests: state => state.requests,
  request: state => state.request,
  vinSummary: state => state.vinSummary,
  vrmSummary: state => state.vrmSummary,
  newVehicle: state => state.newVehicle,
  years: state => state.years,
  makes: state => state.makes,
  models: state => state.models,
  jatoMakes: state => state.jatoMakes,
  jatoModels: state => state.jatoModels,
  jatoYears: state => state.jatoYears,
  jatoMakeSelected: state => state.jatoMakeSelected,
  jatoModelSelected: state => state.jatoModelSelected,
  submodels: state => state.submodels,
  engines: state => state.engines,
  transmissions: state => state.transmissions,
  drivetypes: state => state.drivetypes,
  scantypes: state => state.scantypes,
  serviceelements: state => state.serviceelements,
  requestCount: state => state.requestCount,
  statuslist: state => state.statuslist,
  decodeError: state => state.decodeError,
  totalUnreadChats: state => state.totalUnreadChats,
  requestUnreadReset: state => state.requestUnreadReset,
  requestUnreadCount: state => state.requestUnreadCount,
  noRequest: state => state.noRequest,
  mahleApiErrorMsg: state => state.mahleApiErrorMsg,
  ragratingvehicleid: state => state.ragratingvehicleid,
  ragServiceElements: state => state.ragServiceElements,
  ragDeviceTypes: state => state.ragDeviceTypes
}
